module.exports = __webpack_public_path__ + "img/car-green-right.48a955a4.jpg";